import React, {useState} from 'react'
import config from "../../../../config";
import DropdownSelect from "../../../../components-new/form/DropdownSelect";
import EN from '../../../../assets/flags/EN'
import HY from '../../../../assets/flags/HY'
import {updateLocale} from "../../../../services/user/api";
import {addNotification as addNotificationAction} from "../../../../services/notification/action";
import {updateUserData as updateUserDataAction} from "../../../../services/user/action";
import {connect} from "react-redux";
import LoadingComponent from "../../../../components-new/ui/LoadingComponent";

const LanguageSwitcher = ({user,updateUserData}) => {

    const [locale, setLocale] = useState(user.language);
    const [isLoading, setIsLoading] = useState(false);

    const iconMap = {
        hy:<HY height={16}/>,
        en:<EN height={16}/>
    }

    const handleChange = (val) => {
        if(val.value === locale || isLoading)return
        setIsLoading(true);
        updateLocale(val.value).then(res => {
            if(res){
                updateUserData(res)
                setLocale(val.value)
            }
        }).finally(()=>{
            setIsLoading(false);
        })
    };

    return (
        <DropdownSelect
            options={config.localesOptions}
            selectedValue={locale}
            onChange={handleChange}
            styles={{width: 'auto', height: '36px'}}
            classes="header-language-select"
            renderLabel={(val) => {
                    return (
                        <React.Fragment>
                            {
                                isLoading ?
                                    <div style={{width:'52px', height:'20px'}}>
                                        <LoadingComponent size={20}/>
                                    </div>

                                    :
                                <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                                    {iconMap[val]}
                                    <span>{val.toUpperCase()}</span>
                                </div>}
                        </React.Fragment>
                    )
                }
            }
        >
            {(option) =>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {iconMap[option.value]}
                    <span>{option.title}</span>
                </div>
            }
        </DropdownSelect>
    )
}


const mapDispatchToProps = {
    addNotification: addNotificationAction,
    updateUserData: updateUserDataAction,
};


export default connect(null, mapDispatchToProps)(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/LanguageSwitcher.jsx